export default [
  'ApplicationConfigData',
  class CookiePolicyController {
    constructor (applicationConfigData) {
      this.config = applicationConfigData.getConfig();
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/legal/cookie-policy/cookie-policy.ctrl.js